
import { IIdsRequest } from "../../model/request/IIdsRequest";
import { IDanhSachLuanVanUpdateLockStatusRequest } from "../../model/request/xet-khoa-luan/IDanhSachLuanVanUpdateLockStatusRequest";
import { IXetKhoaLuanSelectByLopRequest } from "../../model/request/xet-khoa-luan/IXetKhoaLuanSelectByLopRequest";
import { apiClient } from "../apiClient";

const DANH_SACH_LUAN_VAN_ENDPOINT = 'danh-sach-luan-van';
export const danhSachLuanVanApi = {
    SelectByLop: (data: IXetKhoaLuanSelectByLopRequest) => apiClient.post(`${DANH_SACH_LUAN_VAN_ENDPOINT}/select-lops`, data),
    UpdateLockStatus: (data: IDanhSachLuanVanUpdateLockStatusRequest) => apiClient.patch(`${DANH_SACH_LUAN_VAN_ENDPOINT}/locks`, data),
    ChuyenThiTotNghiep: (ids: IIdsRequest) => apiClient.post(`${DANH_SACH_LUAN_VAN_ENDPOINT}/chuyen-thi-tot-nghiep`, ids),
}